import { render, staticRenderFns } from "./DsdcCareerSelector.vue?vue&type=template&id=679e5a70"
import script from "./DsdcCareerSelector.vue?vue&type=script&lang=js"
export * from "./DsdcCareerSelector.vue?vue&type=script&lang=js"
import style0 from "./DsdcCareerSelector.vue?vue&type=style&index=0&id=679e5a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports